export default class SvgSpriteMaker
{
    constructor( svg, recreatePlacement = false )
    {
        this.originalSvg = svg;

        this.prepArtboard();
        this.createIndividualShapes();

        if ( recreatePlacement ) {
            this.recreatePlacement();
        }


        this.originalSvg.remove();


        return this.finalShapes;
    }


    prepArtboard()
    {

        // let blob = new Blob([  this.originalSvgCode ], {type: 'image/svg+xml'});
        //     let url = URL.createObjectURL(blob);

        if ( !this.originalSvg.parent ) {
            this.originalSvg = document.body.appendChild( this.originalSvg );
        }

        const viewBox = this.originalSvg.viewBox.baseVal;

        this.originalSvg.style.width  = viewBox.width;
        this.originalSvg.style.height = viewBox.height;


        this.artboard = {
            width         : this.originalSvg.viewBox.baseVal.width,
            height        : this.originalSvg.viewBox.baseVal.height,
            widthAdjusted : this.originalSvg.getBoundingClientRect().width,
            heightAdjusted: this.originalSvg.getBoundingClientRect().height,
            left          : this.originalSvg.getBoundingClientRect().left,
            top           : this.originalSvg.getBoundingClientRect().top,
        }


    }


    createIndividualShapes()
    {
        this.shapes      = [];
        this.finalShapes = [];

        const polygon = this.originalSvg.querySelectorAll( 'polygon' );
        if ( polygon ) {
            this.shapes.polygon = Array.from( polygon );
        }

        const path = this.originalSvg.querySelectorAll( 'path' );
        if ( path ) {
            this.shapes.path = Array.from( path );
        }


        Object.keys( this.shapes ).forEach( ( shapeType ) => {

            this.shapes[ shapeType ].forEach( shape => {


                const shapeBounds = shape.getBoundingClientRect();
                let shapeInfo = {
                    type         : shapeType,
                    x            : shapeBounds.left - this.artboard.left,
                    y            : shapeBounds.top - this.artboard.top,
                    width        : shapeBounds?.width ?? 0,
                    height       : shapeBounds?.height ?? 0,
                    layoutCenterX: shapeBounds.left - this.artboard.left + (shapeBounds.width / 2),
                    layoutCenterY: shapeBounds.top - this.artboard.top + (shapeBounds.height / 2),
                    shapeOriginal: shape,
                    class        : Array.from(shape.classList).join( ' ' ),

                }

                shapeInfo.singleSvg =
                    this.createSingleSvg( shape, shapeInfo );

                this.finalShapes.push( shapeInfo );
            } )
        } )

    }


    createSingleSvg( shape, shapeInfo )
    {
        let svg = document.createElementNS( "http://www.w3.org/2000/svg", "svg" );
        svg.setAttribute( 'width', shapeInfo.width );
        svg.setAttribute( 'height', shapeInfo.height );
        svg.viewBox.baseVal.width  = shapeInfo.width;
        svg.viewBox.baseVal.height = shapeInfo.height;


        let shapesOut;
        if ( 'polygon' === shapeInfo.type ) {
            shapesOut = this.translatePolygonPoints( shape, shapeInfo, svg );
        }
        else if ( 'path' === shapeInfo.type ) {
            shapesOut = this.translatePathPoints( shape, shapeInfo );
        }

        // shapesOut.style.fill = '#000000';


        svg.appendChild( shapesOut );

        return svg;

    }

    translatePolygonPoints( shape, shapeInfo, svg )
    {
        let polygonCopy = document.createElementNS( "http://www.w3.org/2000/svg", "polygon" );

        polygonCopy = this.cloneAttributes( polygonCopy, shape, [ 'points' ] );
        for ( let i = 0; i < shape.points.length; i++ ) {

            const originalPoint = shape.points[ i ];
            let newPoint        = svg.createSVGPoint();
            newPoint.x          = originalPoint.x - shapeInfo.x;
            newPoint.y          = originalPoint.y - shapeInfo.y;

            // console.log( { originalPoint, newPoint } )
            polygonCopy.points.appendItem( newPoint );
        }

        return polygonCopy;

    }

    translatePathPoints( shape, shapeInfo )
    {
        let pathCopy = document.createElementNS( "http://www.w3.org/2000/svg", "path" );

        pathCopy = this.cloneAttributes( pathCopy, shape );


        pathCopy.setAttribute( 'transform', 'translate(' + (-shapeInfo.x) + ', ' + (-shapeInfo.y) + ')' )

        // }

        return pathCopy;

    }

    recreatePlacement()
    {


        // console.info( 'Recreating placement' )
        const container = document.createElement( 'div' );
        container.classList.add( 'final-shapes-container' );
        container.style.position = 'relative';
        container.style.width    = this.artboard.width + 'px';
        container.style.height   = this.artboard.height + 'px';

        this.finalShapes.forEach( ( shape, index ) => {


            const individualContainer = document.createElement( 'div' );
            individualContainer.classList.add( 'shape-container', 'shape-' + index );
            individualContainer.appendChild( shape.singleSvg );
            individualContainer.style.position = 'absolute';

            individualContainer.style.left   = shape.layoutCenterX - (shape.width / 2) + 'px';
            individualContainer.style.top    =
                shape.layoutCenterY - (shape.height / 2) + 'px';
            individualContainer.style.width  = shape.width + 'px';
            individualContainer.style.height = shape.height + 'px';
            individualContainer.draggable    = true;


            container.appendChild( individualContainer );
        } )

        // document.body.appendChild( container );
        // document.querySelector( '.puzzles-out' ).appendChild( container );
    }


    cloneAttributes( target, source, omit = [] )
    {
        [ ...source.attributes ].forEach( attr => {
            target.setAttribute( omit.includes( attr.nodeName )
                                 ? 'data-original-' +
                                   attr.nodeName
                                 : attr.nodeName, attr.nodeValue )
        } )
        return target;
    }
}
